<script setup lang="ts">
    import { computed } from 'vue';

    type Props = {
        page?: string;
    };

    const props = withDefaults(defineProps<Props>(), {
        page: ''
    });

    const isEmpty = computed(() => props.page === '');
</script>

<template>
    <section class="center-large-text section">
        <b-icon
            size="is-large"
            icon="lock-alert"
            class="mb-5" />
        <h1
            class="title">
            Access Denied
        </h1>
        <h1
            v-if="!isEmpty">
            To page: {{ props.page }}
        </h1>
    </section>
</template>

<style scoped>

</style>
